<template>
  <div class="mega-auth-pending" aria-busy="true">
    <span class="pending-status" role="status">현재 페이지를 불러오는 중입니다.</span>
    <div inert aria-hidden="true">
      <header class="pending-header">
        <div class="pending-header-inner">
          <img class="pending-logo" src="@/assets/img/mega-login-logo.png" alt="" />
          <div class="pending-nav"><span>게임실행</span><span>충전/환전</span><span>베팅이력</span><span>공지사항</span><span>고객센터</span></div>
          <div class="pending-account"><i></i><i></i></div>
        </div>
      </header>
      <template v-if="isHome">
        <section class="pending-hero">
          <img src="@/assets/img/mega-login-logo.png" alt="" />
        </section>
        <div class="pending-home-content"><div class="pending-lines"><i></i><i></i><i></i></div></div>
      </template>
      <mega-page-frame v-else :route-name="routeName">
        <div class="pending-lines" :class="{ 'pending-fallback': !hasFrame }"><i></i><i></i><i></i></div>
      </mega-page-frame>
      <main-footer />
    </div>
  </div>
</template>

<script>
import MegaPageFrame from './MegaPageFrame'
import MainFooter from '@/layouts/Footer'

export default {
  name: 'MegaAuthPending',
  components: { MegaPageFrame, MainFooter },
  computed: {
    routeName () {
      return this.$route.name || this.$router.resolve(window.location.pathname).name
    },
    isHome () {
      return ['main', 'mobileMain', 'mobileLogin'].includes(this.routeName)
    },
    hasFrame () {
      return Boolean(MegaPageFrame.computed.heading.call({ routeName: this.routeName, $route: this.$route }))
    }
  }
}
</script>

<style scoped>
.mega-auth-pending { min-height: 100vh; background: #171716; color: #d2d2d2; }
.pending-status { position: absolute; width: 1px; height: 1px; padding: 0; overflow: hidden; clip-path: inset(50%); white-space: nowrap; }
.pending-header { background: #171716; }
.pending-header-inner { width: min(1000px, calc(100% - 32px)); min-height: 68px; margin: auto; display: flex; align-items: center; gap: 34px; }
.pending-logo { width: 105px; height: 66px; object-fit: contain; flex-shrink: 0; }
.pending-nav { display: flex; flex: 1; gap: 24px; font-size: 11px; white-space: nowrap; }
.pending-account { width: 170px; }
.pending-account i, .pending-lines i { display: block; height: 12px; margin: 12px 0; border-radius: 4px; background: #ffffff16; }
.pending-account i:last-child { width: 65%; margin-left: auto; }
.pending-hero { height: 315px; background: url('../../assets/img/mega-main/bg_beautiful01.webp') center top / cover no-repeat; text-align: center; }
.pending-hero img { width: 285px; height: 245px; object-fit: contain; margin-top: 5px; }
.pending-home-content { width: min(872px, calc(100% - 32px)); min-height: 220px; margin: auto; padding: 22px 0; }
.pending-lines { padding: 12px 0; }
.pending-lines i { height: 24px; }
.pending-lines i:last-child { width: 65%; }
.pending-fallback { max-width: 750px; min-height: 376px; margin: auto; }
:deep(.mega-subpanel) { animation: none; }
@media (max-width: 1000px) {
  .pending-header-inner { gap: 20px; }
  .pending-nav { gap: 16px; }
  .pending-account { flex: 1; min-width: 45px; }
}
@media (max-width: 600px) {
  .pending-header-inner { justify-content: center; }
  .pending-nav, .pending-account { display: none; }
  .pending-hero { height: 245px; background-size: auto 100%; }
  .pending-hero img { width: 205px; height: 190px; margin-top: 0; }
}
</style>
